// extracted by mini-css-extract-plugin
export var buttonContainer = "_7n-1";
export var fontSizeSelect = "_7n-3";
export var formatSelect = "_7n-2";
export var formats = "_7n-4";
export var hidden = "_7n-5";
export var icon = "_7n-6";
export var select = "_7n-0";